module.exports = __webpack_public_path__ + "img/tu9.e85b90db.jpg";